import ArcText from 'arc-text';

export default function headings() {
  $('h4').each(function () {
    const arcText = new ArcText($(this).get(0));
    arcText.arc(83);
  });

  $('h1').each(function () {
    $(this).css('--letters', $(this).text().length);
  });
}
